import styled from 'styled-components/native';

export const StoreGrid = styled.View<{rowGap: number}>`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: ${({rowGap}) => rowGap}px;
`;
